const initialState = {
  propertiesCords: [],
};

export const propertiesMapReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case 'PROPERTIES_MAP':
      return { ...state, propertiesCords: action.payload };

    case 'NEARBY_PROPERTIES_MAP':
      return { ...state, nearbyPropertiesCords: action.payload };
      
    case 'SINGLE_PROPERTY_MAP':
      return { ...state, propertyCord: action.payload };
    
    default:
      return state;
  }
};
